import {
   FooterWrapper,
   DownloadBanner,
   BannerContent,
   BannerLeft,
   FooterMain,
   FooterTop,
   FooterColumns,
   FooterBottom,
   FooterBottomContent,
   FooterLinks,
   FooterBrand,
   FooterSocial,
   QrBox,
   QrImg,
   QrText
} from './Footer.styles'
import qrStores from 'src/assets/images/qr_stores.svg'
import ic_facebook from 'src/assets/images/ic_fb.png'
import ic_tiktok from 'src/assets/images/ic_tiktok.png'
import apple_download from 'src/assets/images/apple_download.svg'
import google_download from 'src/assets/images/google_download.svg'
import { Divider } from 'antd'
import { CONTACT_CONFIG } from 'src/helpers/constants'
import { trackContactConversion } from 'src/helpers/googleAdsConversion'

export const Footer = () => {
   const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
   }
   const goToContact = () => {
      window.location.href = '/contact'
   }
   return (
      <FooterWrapper>
         {/* ===== Download App Banner ===== */}
         {/* <DownloadAppBlock /> */}
         <DownloadBanner id="download">
            <BannerContent>
               <BannerLeft>
                  <h1>Tải ứng dụng</h1>
                  <span>Tận hưởng hàng vạn ưu đãi cực khủng</span>
                  <p>
                     Quét mã hoặc click vào một trong 2 nút bên dưới để tải ứng dụng
                     <strong> Xe ghép Thanh Hóa - Hà Nội</strong>
                  </p>

                  <div className="store-buttons">
                     <a
                        href="https://apps.apple.com/us/app/xe-gh%C3%A9p-thanh-ho%C3%A1-h%C3%A0-n%E1%BB%99i/id6755186328"
                        target="_blank"
                        rel="noopener noreferrer"
                     >
                        <img src={apple_download} alt="Tải ứng dụng trên App Store" />
                     </a>
                     <a
                        href="https://play.google.com/store/apps/details?id=com.carpool.thhn"
                        target="_blank"
                        rel="noopener noreferrer"
                     >
                        <img src={google_download} alt="Tải ứng dụng trên Google Play" />
                     </a>
                  </div>
               </BannerLeft>
               <QrBox>
                  <QrImg src={qrStores} alt="Mã QR tải ứng dụng Xe ghép Thanh Hóa - Hà Nội" />
                  <QrText>QUÉT MÃ</QrText>
               </QrBox>
               {/* <BannerRight>
                  <img src="/images/app-mockup.png" alt="Xem trước giao diện ứng dụng" />
               </BannerRight> */}
            </BannerContent>
         </DownloadBanner>

         {/* ===== Main Footer ===== */}
         <FooterMain>
            <FooterTop>
               <FooterBrand id="contact">
                  <span>Liên hệ ngay</span>
                  <a
                     href={`tel:${CONTACT_CONFIG.hotline}`}
                     style={{ color: '#000', fontWeight: '500', fontSize: 12 }}
                     onClick={(event) => trackContactConversion(`tel:${CONTACT_CONFIG.hotline}`, event)}
                  >
                     📞 {`${CONTACT_CONFIG.hotline}`}
                  </a>
               </FooterBrand>

               <FooterSocial>
                  <span>Theo dõi chúng tôi trên</span>
                  <a href={CONTACT_CONFIG.fb_page} target="_blank" rel="noopener noreferrer">
                     <img src={ic_facebook} alt="Trang Facebook LinhLinh36" />
                  </a>
                  <a href={CONTACT_CONFIG.fb_group} target="_blank" rel="noopener noreferrer">
                     <img src={ic_facebook} alt="Nhóm Facebook xe ghép Thanh Hóa Hà Nội" />
                  </a>
                  <a href={CONTACT_CONFIG.tiktok} target="_blank" rel="noopener noreferrer">
                     <img src={ic_tiktok} alt="Kênh TikTok LinhLinh36" />
                  </a>
               </FooterSocial>
            </FooterTop>
            <Divider />
            <FooterColumns>
               <div>
                  <h4
                     onClick={() => {
                        window.location.href = '/'
                     }}
                  >
                     Xe Ghép Thanh Hóa - Hà Nội
                  </h4>
                  <a
                     onClick={() => {
                        window.location.href = '/'
                     }}
                  >
                     LinhLinh36
                  </a>
                  <a>Dịch vụ xe ghép</a>
                  <a
                     onClick={() => {
                        window.location.href = '/terms-and-services'
                     }}
                  >
                     Chính sách & điều khoản
                  </a>
                  <a onClick={goToContact}>Liên hệ</a>
                  <a>Tuyển dụng</a>
               </div>

               <div>
                  <h4>Tuyến hoạt động</h4>
                  <a>Thanh Hóa ⇄ Hà Nội</a>
                  <a>Hà Nội ⇄ Thanh Hóa</a>
                  <a>Đón trả nội thành</a>
                  <a>Đón trả tận nơi</a>
               </div>

               <div>
                  <h4>Dịch vụ</h4>
                  <a>Đặt xe ghép</a>
                  <a>Đặt xe theo chuyến</a>
                  <a>Gửi hàng hỏa tốc</a>
                  <a>Xe chạy hàng ngày</a>
                  <a>Trung chuyển tận nơi</a>
               </div>

               <div>
                  <h4>Loại xe</h4>
                  <a>Xe 4 chỗ</a>
                  <a>Xe 7 chỗ</a>
                  <a>Xe đời mới, không say xe</a>
                  <a>Xe điều hòa mát lạnh, êm ái</a>
               </div>

               <div>
                  <h4>Hỗ trợ khách hàng</h4>
                  <a onClick={goToContact}>Hướng dẫn đặt xe</a>
                  <a onClick={goToContact}>Câu hỏi thường gặp</a>
                  <a onClick={goToContact}>Chính sách hoàn huỷ</a>
                  <a onClick={goToContact}>Liên hệ tổng đài</a>
               </div>
            </FooterColumns>
         </FooterMain>

         {/* ===== Bottom Footer ===== */}
         <FooterBottom>
            <FooterBottomContent>
               <strong onClick={scrollToTop} style={{ cursor: 'pointer' }}>
                  © 2025 LinhLinh36
               </strong>

               <FooterLinks>
                  <a href="/terms-and-services">Điều khoản</a>
                  <a href="/terms-and-services">Chính sách bảo mật</a>
                  <a href="/terms-and-services">Thông báo pháp lý</a>
                  <a href="/contact">Hỗ trợ truy cập</a>
               </FooterLinks>
            </FooterBottomContent>
         </FooterBottom>
      </FooterWrapper>
   )
}
